import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

Vue.config.productionTip = false
Vue.prototype.SERVER_URL = 'https://api.pizza.black';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
